
import { computed, defineComponent } from 'vue';

export default defineComponent({
  name: 'AuthCompleteLayout',

  props: {
    variant: {
      type: String,
      default: 'complete',
      validator: (v: string) => ['complete', 'auth'].includes(v),
    },
  },

  setup() {
    const year = computed(() => new Date().getFullYear());

    return { year };
  },
});
